import BillboardLoading from "../Billboard/BillboardLoading";

export default function MoviesLoading() {
  return (
    <div className="billboard-movies">
      {Array.from({ length: 2 }).map((_, index) => (
        <BillboardLoading key={index} />
      ))}
    </div>
  );
}
